import { render } from "./PriceCardItemTable.vue?vue&type=template&id=885d7394"
import script from "./PriceCardItemTable.vue?vue&type=script&lang=js"
export * from "./PriceCardItemTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__